import styled from "styled-components/macro";
import { useMeasure } from "react-use";

const PrintableRechartStyles = styled.div`
  #print {
    display: none;
  }

  @media print {
    #noPrint {
      display: none;
    }

    #print {
      display: initial !important;
    }
  }
`;

export default function PrintableRechart({
  chart,
  isLandscape = false,
  containerWidthRatio = 1,
  printedChartWidthRatio, // If we are printing in a different format from screen
}: {
  chart: any;
  isLandscape?: boolean;
  containerWidthRatio?: number;
  printedChartWidthRatio?: number;
}) {
  console.log("Using measure PrintableRechart");
  const [ref, { width }] = useMeasure<HTMLDivElement>();
  // TODO arbitrary for now while I am still converting reports over
  const fullChartWidth = isLandscape ? 2000 : 1800;
  const printChartWidthRatio = printedChartWidthRatio || containerWidthRatio;

  return (
    <PrintableRechartStyles>
      <div ref={ref} id="noPrint">
        {chart(width * containerWidthRatio)}
      </div>
      <div id="print">{chart(fullChartWidth * printChartWidthRatio)}</div>
    </PrintableRechartStyles>
  );
}
